import { Component, OnInit, Input } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {AppComponent} from '../../app.component';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { AlertService } from '../../alertpopup/_alert';
@Component({
    selector: 'app-import-data',
    templateUrl: './import-data.component.html',
    styleUrls: ['./import-data.component.css'],
    standalone: false
})
export class ImportDataComponent implements OnInit {
  @Input() formData: FormData[];
  form: FormGroup;
  ProfileID: number;
  url: string;
  ModuleData: any;
  pageurl: string;
  EDIData: any;
  fileurls = [];  
  fileName: string;
  EDIRowID: string;
  Status: number;
  CurrentStep: number;
  Msg: string;
  class: string;
  ImportType: string;
  loading: boolean;
  DownloadURL: string;
  DownloadFilePath: string;
  TargetFile: string;
  options = {
    autoClose: true,
    keepAfterRouteChange: false
  };

  constructor(private router: Router, private http: HttpClient, private formBuilder: FormBuilder, protected alertService: AlertService) {
    this.url = AppComponent.baseURL;
    this.DownloadURL = AppComponent.DownloadURL;
   }

  ngOnInit() {
    this.loading = false;
    this.pageurl = this.router.url;
    let pagehead = this.pageurl.split('/');
    this.ProfileID = Number(pagehead[2]);
    this.CurrentStep = 1;
    this.Status = 200;

    if (this.ProfileID == 0) {
      this.ImportType = "Decision";
    } else if (this.ProfileID == 1) {
      this.TargetFile = "assets/resources/document/LexMantra_EDIFile.xlsx";
      this.ImportType = "Notice";
    } else if (this.ProfileID == 2) {
      this.TargetFile = "assets/resources/document/LexMantra_EDIFileCase.xlsx";
      this.ImportType = "Case";
    } else if (this.ProfileID == 3) {
      this.ImportType = "Contact";
    } else if (this.ProfileID == 4) {
      this.ImportType = "Organisation"; }

    this.GetEDITemplate();
  }

  GetEDITemplate() {
    const formGroup = {};
    this.form = new FormGroup(formGroup);

    this.http.get(this.url + 'Import/GetEDITemplate?ProfileID=' + this.ProfileID)
    
    .subscribe( (data) => {
        if (data == null || data.toString() == "[]") {
        } else {
          this.formData = JSON.parse(data.toString());
          this.formData.forEach(formControl => {
            formGroup[formControl.Field] = new FormControl("");
            this.form = new FormGroup(formGroup);
          });
          for (var val of JSON.parse(data.toString())) {
            (this.form.get(val.Field) as FormControl).patchValue(val.SelectedValue);
          }
        }
      },
      (error) => {
       }
    );
  }

  onSelectFile(event) {
    this.fileurls = [];
    this.fileName = '';
    if (event.target.files && event.target.files[0]) {
          this.fileName += event.target.files[0].name + ',';
          let reader = new FileReader();
          reader.onload = ( event: any) => { this.fileurls.push(event.target.result); };
          reader.readAsDataURL(event.target.files[0]);
    }
  }

  onSubmit() {

    this.Msg = "";
    if (this.fileName == null || this.fileName=="")
    {
      this.alertService.warn('Please choose file.',this.options);
      return;
    }
    this.loading = true;
    let data: EDIFileData = {
       fileBase: this.fileurls,
       fileName: this.fileName,
       ProfileID : this.ProfileID
    };
    this.http.post(this.url + 'Import/UploadFile', data) .subscribe( (data : ColumnList) => {
          this.loading = false;
          if (data.Status != 200)  {
            this.loading = false;
            this.Msg = data.Message;
            this.Status = 401;
            return;
          }
          this.EDIRowID = data.EDIRowID;
          this.ModuleData = JSON.parse(data.colList.toString());
          this.CurrentStep = 2;
        },
        (error) => {
          this.loading = false;
          this.Msg = "Internal Server Error.";
          this.Status = 401;
        }
      );
  }

  SaveMapping() {
    this.loading = true;
    let finalData: FinalData;
    finalData = new FinalData();
    finalData.ColMappingData = this.form.value;
    finalData.EDIRowID = this.EDIRowID;
    finalData.FileName = this.fileName;
    finalData.ProfileID = this.ProfileID;
    this.http.post(this.url + 'Import/SaveMapping', finalData) .subscribe( (data) => {
      this.loading = false;
      this.CurrentStep = 3;
      let arr = data.toString().split("|");
      this.Msg = arr[0];
      this.DownloadFilePath = arr[1].replace("~" , "/");
      },
      (error) => {
        this.loading = false;
        this.Msg = "Internal Server Error.";
      }
    );

  }
}

export class EDIFileData {
  fileBase = [];
  fileName: string;
  ProfileID: number;
}

export interface FormData {
  ID: string;
  Caption: string;
  Field: string;
  Description: string;
  placeholder?: string;
  SelectedValue?: string;
}

export interface ColumnList {
  colList: string;
  EDIRowID: string;
  Status: number;
  Message: string;
}

export class FinalData {
  ColMappingData: any;
  EDIRowID: string;
  ProfileID: number;
  FileName: string;
}
